const {
	fillWithDomElements,
	fillWithDomElementsAll,
	addEventsTo,
	toggleMenuArias,
	getFocusablesFrom,
	trackGtm,
	trackSeeMore,
	disableStaticURL,
} = require('../../../../js/functions');
const { DELAY_DEBOUNCE } = require('../../../../js/consts');
const {
	stuttering,
	default: onWidthResize,
} = require('../../../../js/onWidthResize');

const CLASS_TITLE = 'table-widget--title';
const CLASS_DOWNLOAD = 'table-widget--download';
const CLASS_CONTAINER = 'table-widget--container';
const CLASS_CONTENT = 'table-widget--content';
const CLASS_TABLE = 'table-widget--table';
const CLASS_FOOTNOTE = 'table-widget--footnote';
const CLASS_LAST_BULLET = 'is-last-bullet';
const CLASS_TABLE_ROW = 'table-widget--row';
const CLASS_HEAD = 'table-widget--head';
const CLASS_SHOW_MORE = 'table-widget--more-button';
const CLASS_SHOW_MORE_LABEL = 'table-widget--show-more-label';
const CLASS_SHOW_LESS_LABEL = 'table-widget--show-less-label';

const CLASS_HIGHLIGHTED = 'highlighted';
const CLASS_IS_TITLE = 'is-title';
const CLASS_ACTIVE = 'active';

const selectorsClasses = {
	title: CLASS_TITLE,
	dowloadLink: CLASS_DOWNLOAD,
	container: CLASS_CONTAINER,
	table: CLASS_TABLE,
	content: CLASS_CONTENT,
	tableHead: CLASS_HEAD,
	showMoreButton: CLASS_SHOW_MORE,
	showMoreLabel: CLASS_SHOW_MORE_LABEL,
	showLessLabel: CLASS_SHOW_LESS_LABEL,
};
const selectorsAllClasses = {
	footnotes: CLASS_FOOTNOTE,
	lastBullets: CLASS_LAST_BULLET,
	rows: CLASS_TABLE_ROW,
};

module.exports = {
	init() {
		fillWithDomElements(this, selectorsClasses);
		fillWithDomElementsAll(this, selectorsAllClasses);
		this.rows = this.table.querySelectorAll('tbody tr');
		// provide an array of indexes of last bullets
		this.lastBulletsIndexes = [...this.lastBullets].map(bullet =>
			[...bullet.parentElement.children].indexOf(bullet),
		);
		this.rowsToShowLonger =
			parseInt(this.root.dataset.rowsToShow) >= this.rows.length + 1;
		this.opened = false;
		this.dowloadLink.addEventListener('click', e => {
			this.trackDownload(e.target);
			disableStaticURL(e.target, 'download-disabled');
		});
		this.initFootnotes();
		onWidthResize(
			() => this.setOpen(false),
			stuttering.DEBOUNCE,
			DELAY_DEBOUNCE,
		);
		this.initHeight();

		if (this.root.dataset.expended === 'true') {
			this.showMoreButton.style.display = 'none';
		} else {
			this.showMoreButton.addEventListener('click', this.toggleOpen.bind(this));
		}
	},
	initHeight() {
		this.initialHeight = 0;
		if (this.root.dataset.expended === 'true') {
			this.setOpen(true);
			return;
		}
		const rowsToShow = this.rowsToShowLonger
			? this.rows.length
			: parseInt(this.root.dataset.rowsToShow);

		for (let index = 0; rowsToShow > index; index++) {
			this.initialHeight += this.rows[index].offsetHeight;
		}
		if (this.rowsToShowLonger) {
			this.setOpen(true);
		} else if (rowsToShow || !parseInt(this.root.dataset.rowsToShow)) {
			this.container.style.height = this.initialHeight + 'px';
		}
	},
	trackDownload({ target }) {
		const { href, textContent } = target;
		trackGtm({
			eventCategory: 'outgoing tracking',
			eventAction: 'download',
			eventLabel: `${textContent} | ${href}`,
		});
	},
	highlightElement(elements, row, does) {
		const selected = elements[row];
		const isColumn = selected.tagName === 'TH';
		const isTitle = selected.classList.contains(CLASS_IS_TITLE);
		const index = [...selected.parentElement.children].indexOf(selected);
		if (selected) {
			if (isColumn) this.highLightColumn(index, does);
			else if (isTitle) this.highlightRelatedToTitle(index, does);
			else selected.classList[does ? 'add' : 'remove'](CLASS_HIGHLIGHTED);
		}
	},
	highlightRelatedToTitle(selected, does) {
		const last = Math.min(
			...this.lastBulletsIndexes.filter(diff => diff - selected >= 0),
		);
		[...this.rows]
			.slice(selected, last + 1)
			.forEach(row =>
				row.classList[does ? 'add' : 'remove'](CLASS_HIGHLIGHTED),
			);
	},
	highLightColumn(column, does) {
		this.rows.forEach(row => {
			const currentColumn = row.children[column];
			currentColumn.classList[does ? 'add' : 'remove'](CLASS_HIGHLIGHTED);
		});
	},
	initFootnoteFrom(index, element, elements, clickEvent) {
		addEventsTo(element, {
			mouseover: () => {
				this.highlightElement(elements, index, true);
			},
			mouseout: () => {
				this.highlightElement(elements, index, false);
			},
			click: clickEvent,
		});
	},
	listTableFootnotes() {
		const result = {};
		this.table.querySelectorAll('tr.footnoted').forEach(row => {
			result[row.querySelector('td sup').innerText - 1] = row;
		});
		return result;
	},
	listHeadsFootnotes() {
		const result = {};
		[...this.table.querySelectorAll('th')]
			.map(element => ({ element, sup: element.querySelector('sup') }))
			.filter(header => header.sup)
			.forEach(header => {
				const sup = header.sup.innerText - 1;
				result[sup] = header.element;
			});
		return result;
	},
	initFootnotes() {
		this.notesRows = this.listTableFootnotes();
		this.notesColumns = this.listHeadsFootnotes();
		this.tablesNotes = {
			...this.notesRows,
			...this.notesColumns,
		};

		this.footnotes.forEach((note, index) => {
			this.initFootnoteFrom(index, note, this.tablesNotes, () => {
				this.goTo(this.tablesNotes[index]);
			});
			const relativeRow = this.notesRows[index];
			if (relativeRow)
				this.initFootnoteFrom(index, relativeRow, this.footnotes, () => {
					this.goTo(this.footnotes[index]);
				});
		});
	},
	isFootNoteColumn(number) {
		return !!this.notesColumns[number];
	},
	goTo(element) {
		const nav = document.querySelector('.nav-layout');
		const padding = nav ? nav.offsetHeight : 0;
		if (window.scrollTo)
			window.scrollTo({
				top: window.pageYOffset + element.getBoundingClientRect().top - padding,
				behavior: 'smooth',
			});
	},
	toggleOpen() {
		this.setOpen(!this.opened);
		trackSeeMore(this.title.textContent, 'table-widget', this.opened);
	},
	setOpen(open) {
		this.opened = open;
		this.showMoreLabel.classList[this.opened ? 'remove' : 'add'](CLASS_ACTIVE);
		this.showLessLabel.classList[this.opened ? 'add' : 'remove'](CLASS_ACTIVE);
		if (this.opened || this.root.dataset.expended === 'true') {
			const contentHeight = this.content.offsetHeight;
			this.container.style.height = contentHeight + 'px';
		} else this.container.style.height = this.initialHeight + 'px';
		toggleMenuArias(this.title, getFocusablesFrom(this.container) || [], open);
	},
};
